import { gql } from '@apollo/client';

const IMPORT_C1C_STUDY_MUTATION = gql`
  mutation importC1cStudy($externalId: String!) {
    importC1cStudy(externalId: $externalId) {
      isSuccess
      errorCode
      study {
        id
        friendlyId
      }
    }
  }
`;

export default IMPORT_C1C_STUDY_MUTATION;
